import Vuex from 'vuex'

import {
  application,
  progressModal,
  user,
  userPassword,
  users,
  userFilters,
  staff,
  staffFilters,
  client,
  clients,
  clientFilters,
  assignment,
  assignments,
  assignmentFilters,
  consultantTimeSheet,
  staffTimeSheet,
  timeCardReport,
  timeCardReportFilters,
  notifications,
  authentication,
  employeeTypes,
  employeePayrollTypes,
  billRateTypes,
  payRateTypes,
  payFrequencies,
  directPlacements,
  directPlacementFilters,
  directPlacement,
  commissionsTiers,
  commissionDetailsReport,
  commissionDetailsReportFilters,
  commissionReport,
  commissionReportFilters,
  invoicingReport,
  invoicingReportFilters,
  payrollReport,
  payrollReportFilters,
  directPlacementPayment,
  directPlacementPayments,
  gpToCostReport,
  gpToCostReportFilters,
  dashboard,
  contractTypes,
  invoiceFrequencies,
  deal,
  deals,
  dealFilters,
  dealStatuses,
  dealClient,
  dealCandidate,
  dealAssignment,
  todo,
  todos,
  todoFilters,
  todoGroups,
  todoGroup,
  todoNoteFilters,
  todoNotes,
  todoNote,
  overtimeEntries,
  expensesTypes,
  oneOffFeesRecords,
  teams,
  thirdPartyPortals,
  settings,
  zohoIntegration,
  placementGoals,
  directPlacementGoals,
  expenseAmountTypes,
  dashboardLayout,
  biweeklyPeriods,
  periods,
  revenueData,
  consultantsEditedTotalPay,
  staffEditedTotalPay,
  editedTotalBill,
  clockLogs,
  datetimeHelper,
  clockLogsReport,
  timeManagement
} from './modules'

const store = {
  modules: {
    application,
    progressModal,
    user,
    userPassword,
    users,
    userFilters,
    staff,
    staffFilters,
    client,
    clients,
    clientFilters,
    assignment,
    assignments,
    assignmentFilters,
    consultantTimeSheet,
    staffTimeSheet,
    timeCardReport,
    timeCardReportFilters,
    notifications,
    authentication,
    employeeTypes,
    employeePayrollTypes,
    billRateTypes,
    payFrequencies,
    payRateTypes,
    directPlacements,
    directPlacementFilters,
    directPlacement,
    commissionsTiers,
    commissionDetailsReport,
    commissionDetailsReportFilters,
    commissionReport,
    commissionReportFilters,
    invoicingReport,
    invoicingReportFilters,
    payrollReport,
    payrollReportFilters,
    directPlacementPayment,
    directPlacementPayments,
    gpToCostReport,
    gpToCostReportFilters,
    dashboard,
    contractTypes,
    invoiceFrequencies,
    deal,
    deals,
    dealFilters,
    dealStatuses,
    dealClient,
    dealCandidate,
    dealAssignment,
    todo,
    todos,
    todoFilters,
    todoGroups,
    todoGroup,
    todoNoteFilters,
    todoNotes,
    todoNote,
    overtimeEntries,
    expensesTypes,
    oneOffFeesRecords,
    teams,
    thirdPartyPortals,
    settings,
    zohoIntegration,
    placementGoals,
    directPlacementGoals,
    expenseAmountTypes,
    dashboardLayout,
    biweeklyPeriods,
    periods,
    revenueData,
    consultantsEditedTotalPay,
    staffEditedTotalPay,
    editedTotalBill,
    clockLogs,
    datetimeHelper,
    clockLogsReport,
    timeManagement
  }
}

export default () => new Vuex.Store(store)
